import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { useCalm } from './time';

/** Lobby tips, one at a time, in the voice-line face (.hand). The tips themselves live in lib/kudos.ts (LOBBY_TIPS). */
export function TipCarousel({ tips, intervalMs = 5200 }: { tips: readonly string[]; intervalMs?: number }) {
  const [i, setI] = useState(0); const reduce = useCalm();
  useEffect(() => {
    if (tips.length < 2) return;
    const t = window.setInterval(() => setI((n) => (n + 1) % tips.length), intervalMs);
    return () => window.clearInterval(t);
  }, [tips.length, intervalMs]);
  if (!tips.length) return null;
  return (
    <figure className="relative overflow-hidden rounded-tile border border-line bg-surface px-4 pb-6 pt-4 shadow-card">
      <div className="relative min-h-[4.5rem]">
        <AnimatePresence mode="wait" initial={false}>
          <motion.p key={i} initial={reduce ? { opacity: 0 } : { opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={reduce ? { opacity: 0 } : { opacity: 0, y: -8 }} transition={{ duration: 0.28 }}
            className="text-[1.4rem] leading-snug text-ink hand">
            {tips[i]}
          </motion.p>
        </AnimatePresence>
      </div>
      {/* Which tip is showing: square ticks, one lit, never dots. */}
      <div aria-hidden="true" className="absolute bottom-2.5 left-4 flex gap-1.5">
        {tips.map((_, n) => <span key={n} className={`h-1.5 w-4 transition-colors duration-300 ${n === i ? 'bg-brand' : 'bg-line'}`} />)}
      </div>
    </figure>
  );
}
